// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("admin." + chunkId + ".2.25.0.js");